<template>

  <!--begin: Form Body -->
  <div>
    <div class="tpl-box" :style="{  minHeight : height + 'px' }">
      <div class="fill-success" v-show="success">
        <div :style="{ paddingTop : height/2 -160 + 'px' }"><img width="60" src="@/assets/success.png"></div>
        <div class="fill-title">{{ success_msg }}</div>
        <div class="fill-des">
          <div>{{ tpl.is_manage ? '如果合同还需要他人填写，请点击邀请他人填写' : '恭喜您，您已经完成了本次操作' }}</div>
          <div v-if="tpl.is_manage" class="btn" @click="invitation"
               style="background: rgb(160, 160, 160); margin-top: 20px; max-width: 140px">邀请他人填写
          </div>

          <div v-if="tpl.is_manage && showCreateDoc" class="btn" @click="createWords"
               style=" margin-top: 20px; max-width: 140px ; margin-left: 15px">创建合同
          </div>

        </div>
      </div>
      <div class="fill-content" v-show="!success">
        <div id="tpl_content"></div>
      </div>

      <qr-link :link="url" :show="showQrcode" @close="showQrcode = false"></qr-link>

    </div>

    <!--   wap 按钮-->
    <div v-if="client==='mobile'">
      <div class="right-tool-mobile" v-if="!success">
        <div class="right-tool-mobile-box flex-center">
          <div style="width: 50%;  " @click="create" v-if="!tpl.fill_status">
            <div class="btn" style="width: 85%">确认填写内容</div>
          </div>
          <div style="width: 50%;" v-if="!success && tpl.is_manage">
            <div class="btn" @click="getLink" style="background: #828282; width: 85%" >邀请他人填写</div>
          </div>
        </div>
      </div>
    </div>
    <!--    wap 按钮结束-->

  </div>
</template>

<script>
import LoadTemplate from "./js/LoadTemplate"
import QrLink from "@/components/qr-link";
import appClient from "@/conf/js/appClient";

// import uni from "uni";

export default {

  name: "create",
  /**
   * 接受消息
   */
  mounted() {
    window.onload = () => {
      window.addEventListener('message', json => {
        console.log(json.data.action)
        switch (json.data.action) {
          case "create" :
            return this.create();
          case "getLink" :
            return this.getLink()
        }
      }, false)
    }

      if (this.client==='mobile')
        appClient.init();

  },
  data() {
    return {
      client : this.$route.query.client || 'mobile',
      url: "", // 二维码链接
      fill_id: "", //填写的id
      success: false, //成功提示
      showQrcode: false, //是否显示二维码
      height: 600, // 页面高度
      success_msg: "内容填写成功",
      showCreateDoc: false, //是否显示创建合同按钮
      tpl: {
        fill_status: true,
        id: this.$route.query.id,
        is_manage: false, //是否管理
        file_id: "",
        field: []
      }
    };
  },

  components: {QrLink},
  methods: {


    /**
     * 邀请他人填写
     * @returns {*}
     */
    invitation() {

      if (this.client==='mobile') {
        return    uni.navigateTo({
          url : "/pages/users/v3template/qrcode?url=" + this.url
        })
      }

      this.showQrcode = true

    },
    /**
     * 获取链接
     */
    getLink() {

      if (!this.tpl.file_id)
        return this.api.alert("请等待系统加载完成")

      this.api.loading()
      this.api.post("/v1/V31Template/getLink", {
        id: this.tpl.id,
        field: this.tpl.field,
        fill_id: this.fill_id
      }, json => {
        this.api.hideLoading()
        if (json.code === 200) {
          this.fill_id = json.data.fill_id
          this.url = json.data.url
          this.success = true
          this.success_msg = "请等待他人填写"

          if (this.client==='mobile') {
            return    uni.navigateTo({
               url : "/pages/users/v3template/qrcode?url=" + this.url
             })
          }
          else {
            this.showQrcode = true
            //隐藏按钮
            window.parent.postMessage({
              action: 'hideCreateBtn'
            }, '*')
          }
        } else
          this.api.alert(json.msg);
      });
    },

    /**
     * 创建合同
     */
    createWords() {



      //如果是app
      if (this.client==='mobile')
      {

        return  uni.redirectTo({
          url: "/pages/users/contractManagement/createDoc?fill_id=" + this.fill_id
        }) ;

      }
      window.parent.postMessage({
        action: 'createDoc',
        fill_id: this.fill_id
      }, '*')
    },
    /**
     * 读取数据
     */
    read() {
      this.api.loading()
      this.api.post(
          "/v1/V31Template/read",
          {
            id: this.tpl.id,
            fill_id: this.fill_id
          }, (json) => {
            if (json.code === 200) {
              this.tpl = json.data

              if (this.$route.query.channel === "api")
                this.tpl.is_manage = false

              LoadTemplate.html(this)
              setTimeout(() => {
                this.api.hideLoading()
              }, 1200);
            } else if (json.code === 402) {
              setTimeout(() => {
                this.read();
              }, 10000)
              this.api.alert(json.msg)
            } else if (json.code === 103) {
              this.api.hideLoading()
            } else {
              this.api.hideLoading()
              this.api.alert(json.msg)
            }
          })
    },

    /**
     * 创建数据
     */
    create() {

      if (!this.tpl.file_id)
        return this.api.alert("请等待系统加载完成")

      this.api.loading()

      this.api.post("/v1/V31Template/v31fill", {
        id: this.tpl.id,
        field: this.tpl.field,
        fill_id: this.fill_id
      }, json => {
        this.api.hideLoading()
        if (json.code === 200) {
          this.fill_id = json.data.fill_id
          this.url = json.data.url
          this.success = true
          this.showCreateDoc = true
          //隐藏按钮
          window.parent.postMessage({
            action: 'hideCreateBtn'
          }, '*')

        } else
          this.api.alert(json.msg);
      });
    }


  },
  created() {
    this.fill_id = this.$route.query.fill_id || ""
    this.read()
    this.height = document.documentElement.clientHeight
  }
};
</script>
<style scoped>

.flex-center {
  /*justify-content: flex-start | flex-end | center | space-between | space-around;*/
  justify-content: center;
}

.fill-title {
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  color: #585858;
  margin-bottom: 10px;
}

.fill-des {
  color: #acacac;
  font-weight: 300;
  margin-top: 5px;
  font-size: 12px
}


.fill-success img {
  width: 60px;
}


input {
  background: #f7bbbbad;
  cursor: auto;
  border: none;
  border-radius: 6px;
}

.id-tpl-content img {
  max-width: 600px;
  width: 100%;
}

.id-tpl-content .loading-indicator {
  display: none;
}

</style>
